module.exports = __webpack_public_path__ + "img/login.909ae4cd.png";